export default "__VITE_ASSET__DPA3pVJF__"